import React from 'react';
import { Link, withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function MainSidebarItemGroup(props) {
  const {
    to, children, location, icon, label, matcher, disabled, badge,
  } = props;

  const isActive = !disabled && location.pathname.includes(matcher);
  const isReactRoute = to.startsWith('/s/');

  const liClassName = [
    isActive ? 'active' : '',
    disabled ? 'disabled-nav-item' : '',
  ].filter(Boolean).join(' ');

  const labelNode = typeof label === 'string'
    ? <span className="menu-item-parent">{label}</span>
    : label;

  if (disabled) {
    return (
      <li className={liClassName}>
        {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
        <a
          href="#"
          aria-disabled
          className="d-flex align-items-center"
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
          }}
        >
          <FontAwesomeIcon icon={icon} className="fa-fw" size="lg" />
          {labelNode}
          <span />
          {badge && <span className="ml-auto">{badge}</span>}
        </a>
      </li>
    );
  }

  const linkContent = (
    <>
      <FontAwesomeIcon icon={icon} className="fa-fw" size="lg" />
      {labelNode}
      <span />
      {badge}
    </>
  );

  return (
    <li className={liClassName}>
      {isReactRoute ? (
        <Link to={to}>{linkContent}</Link>
      ) : (
        <a href={to}>{linkContent}</a>
      )}
      {isActive && children ? (<ul>{children}</ul>) : null}
    </li>
  );
}

MainSidebarItemGroup.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  children: PropTypes.node,
  matcher: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  badge: PropTypes.node,
};

MainSidebarItemGroup.defaultProps = {
  children: null,
  disabled: false,
  badge: null,
};

export { MainSidebarItemGroup };

export default withRouter(MainSidebarItemGroup);
